import { useRef, type RefObject } from 'react';

const useFileSelectorControls = (): [
  RefObject<HTMLInputElement | null>,
  () => void,
  () => void,
] => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openFileSelector = async (): Promise<void> => {
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };

  const resetFileSelectorState = (): void => {
    if (inputRef.current !== null) {
      inputRef.current.value = '';
    }
  };

  return [inputRef, openFileSelector, resetFileSelectorState];
};

export default useFileSelectorControls;
